export const formatTransactionAddress = (address) => {
  if (address) {
    return `${address.Line1}${address.Line2 ? ' #' + address.Line2 : ''},  ${address.City}, ${
      address.State
    }`;
  }

  return '';
};
